module.exports = "/static/assets/5d21b51a41ba85b7852eb879dcc0ee30.png";